module.exports = __webpack_public_path__ + "static/img/culture4.9c20c5a8.jpg";